import { Card, Button, Input } from 'antd';

import Cookies from 'js-cookie'

export const CookieAttribute = ({ onDone }: AttributeInput) => {
  const onCookieRemove = () => {
    Object.keys(Cookies.get()).forEach(function(cookieName) {
      const neededAttributes = {
        // Here you pass the same attributes that were used when the cookie was created
        // and are required when removing the cookie
      };
      Cookies.remove(cookieName, neededAttributes);
    });
  }

  const onRefresh = () => {
    window.location.reload()
  }

  const bodyMinHeightStyle = {
    minHeight: '160px'
  }

  return (
    <Card
      bodyStyle={bodyMinHeightStyle}
      title="쿠키 초기화"
      bordered={true}>
      <div>
        <Button type="dashed" danger onClick={(e) => onCookieRemove() }>쿠키 초기화</Button>
      </div>
      <div style={{marginTop: '14px'}}>
        <Button type="dashed" onClick={(e) => onRefresh() }>새로 고침</Button>
      </div>
    </Card>
  )
}
